<template>
  <div class="navbar">
    <div class="right-menu">
      <template>
        <div class="bartag">
          <img src="../../assets/img/back.png" :style="barflag ? 'transform:rotate(180deg)' : ''" @click="setside" />
          {{ $route.name }}
        </div>
      </template>
    </div>
    <el-dropdown trigger="click" @command="handleCommand">
      <div class="box-container">
        <img :src="user.userImage ? user.userImage : avator" style="border-radius: 50%" />
        <div class="boxc-name">
          {{ user.userName }} <i class="el-icon-caret-bottom"></i>
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="1">个人中心</el-dropdown-item>
        <el-dropdown-item command="2">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="联系电话" :visible="phone.length > 0" :before-close="closedia" append-to-body>
      <div class="alog">
        <p><span>*</span>联系电话</p>
        <div>{{ phone }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      video: false,
      width: 30,
      device: true,
      user: {},
      avator: require("../../assets/img/head.png"),
      notice: {},
      phone: "",
      barflag: false,
      route: {},
    };
  },
  mounted() {
    this.barflag = this.$root.barflag;
    this.init();
    // this.user={
    //   nickName: '李潇潇',

    // }
  },
  methods: {
    init() {
      this.$get("/api/company/companyUser/getCompanyUserInfo", {}).then((res) => {
        this.user = res.data;
        this.$cookie.set('authType',res.data.authType)
      });
    },
    handleCommand(e) {
      if (e == 1) {
        this.goperson();
      } else if (e == 2) {
        this.logout();
      }
    },
    goperson() {
      this.$router.push("/personalCenter");
    },
    async logout() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post('/api/company/companyUser/companyUserLogout', {}).then((res) => {
          if (res.code == 200) {
            this.$cookie.remove('companyUserId')
            window.location.href = '/login'
            document.body.style.overflow = 'auto'
            this.$router.push('/login')
          }
        })
      })
    },
    setside() {
      this.barflag = !this.barflag;
      this.$root.barflag = !this.$root.barflag;
    },
    broadcast() {
      this.$router.push("/personal");
    },
    gonotice() {
      var href = window.location.href;
      var is = href.indexOf("notice") == -1;
      if (is) {
        this.$router.push("/notice");
      }
    },
    setphone() {
      this.$postRequest("/mall/shopExtract/platPhone", {}).then((res) => {
        if (res.code == 200) {
          this.phone = res.data.phone;
        }
      });
    },
    closedia() {
      this.phone = "";
    },
  },
};
</script>

<style scoped>
.navbar {
  width: 100%;
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #22459f;
  /* box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08); */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navbar .box-container .hamburger-container {
  line-height: 46px;
  height: 100%;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.box-container {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  cursor: pointer;
}

.box-container>img {
  width: 40px;
  height: 40px;
  padding: 5px 0;
  display: block;
}

.boxc-name {
  margin-left: 10px;
  font-size: 16px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #ffffff;
  margin-right: 20px;
}

.breadcrumb-container {
  float: left;
}

.notice-box {
  width: 500px;
  height: 30px;
  background: #919cad;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.notice-box img {
  width: 17px;
  height: 15px;
  margin: 0 32px 0 20px;
}

.notice-box div {
  width: calc(100% - 80px);
  line-height: 30px;
  font-size: 14px;
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bartag {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #c5d3f8;
}

.bartag>img {
  width: 20px;
  height: 20px;
  margin-right: 16px;
  margin-left: 20px;
  transform-origin: center center;
  cursor: pointer;
}

.right-menu {
  float: right;
  height: 100%;
  line-height: 50px;
  display: flex;
  align-items: center;
}

.right-box {
  width: 30px;
  height: 30px;
  margin: 0 30px 0 0;
  position: relative;
}

.right-box img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
}

.right-box span {
  display: block;
  height: 15px;
  background: #e60012;
  border-radius: 8px;
  padding: 0 5px;
  position: absolute;
  top: -7px;
  right: -15px;
  line-height: 15px;
  color: #ffffff;
}

.right-box1 {
  height: 60px;
  margin: 0 30px 0 0;
  display: flex;
  align-items: center;
}

.right-box1 div {
  margin: 0 30px 0 0;
  line-height: 70px;
}

.right-menu-item {
  display: inline-block;
  padding: 0 8px;
  height: 100%;
  font-size: 18px;
  color: #5a5e66;
  vertical-align: text-bottom;
}

.avatar-container {
  margin-right: 30px;
}

.avatar-container .avatar-wrapper {
  margin-top: 5px;
  position: relative;
}

.user-avatar {
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 10px;
}
</style>
